var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H16C7.16344 0 0 7.16344 0 16V48C0 56.8366 7.16344 64 16 64H48C56.8366 64 64 56.8366 64 48V16C64 7.16344 56.8366 0 48 0Z",
    fill: "#FF9500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 15C35.2833 15 42 20.7533 42 27.85C42 34.945 35.2833 40 27 40C25.3 40 23.6683 39.7583 22.1467 39.3133C20.4467 40.625 18.075 42.4233 14.5 43.3133C14.3309 43.3557 14.1521 43.3318 14 43.2467C13.9214 43.2038 13.852 43.1458 13.796 43.076C13.7399 43.0062 13.6983 42.9259 13.6735 42.8399C13.6487 42.7538 13.6412 42.6637 13.6515 42.5748C13.6617 42.4858 13.6896 42.3998 13.7333 42.3217L13.99 41.8617C15.1783 39.695 15.6517 37.9183 15.945 36.5317C13.495 34.245 12 31.1967 12 27.8483C12 20.7533 18.7167 15 27 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0017 43.3333C29.655 45.4317 33.285 46.6617 37.29 46.6617C38.9567 46.6617 40.5567 46.42 42.05 45.9733L42.065 45.985C43.7317 47.2983 46.0083 49.0917 49.5033 49.98C49.67 50.0217 49.845 49.9967 49.9933 49.9133C50.1502 49.8244 50.2655 49.6771 50.3142 49.5035C50.3629 49.33 50.341 49.1442 50.2533 48.9867L50.0033 48.5267C48.8367 46.3567 48.42 44.5767 48.13 43.1883C50.5333 40.8983 52 37.845 52 34.4917C52 29.7217 49.0333 25.5583 44.6283 23.3367C45.0975 24.7945 45.3353 26.3169 45.3333 27.8483C45.3333 37.4667 36.3617 43.3333 27.0017 43.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopics);
export default __webpack_public_path__ + "static/media/topics.88bd2be7e818e1ac1640a466214e2519.svg";
export { ForwardRef as ReactComponent };